<template>
    <b-modal
    v-model="modalShow"
    hide-footer
    :title="title"
    @hide="close"
    size="lg">
      <div id="street"></div>
    </b-modal>
</template>

<style>
#street {
  width: 100%;
  height: 500px;
  margin:0;
  padding: 0;
}
</style>

<script>
import Loader from '@/components/Layout/Loader.vue';
export default {
  name: 'StreetView',
  components: {
    Loader
  },
  data () {
    return {
      modalShow: false,
      title: ''
    };
  },
  methods: {
    close: function () {
      this.$emit('close');
    },
    initStreet: function (e) {
      var panorama = new self.google.maps.StreetViewPanorama(
        document.getElementById('street'),
        {
          position: {lat: e.latlng.lat, lng: e.latlng.lng},
          pov: {heading: 0, pitch: 0},
          zoom: 1
        });
      return panorama;
      // console.log(panorama)
    },
    getInfo: function (e) {
      this.modalShow = true;
      this.initStreet(e);
      var th = this;
      self.$.ajax({
        url: 'https://maps.googleapis.com/maps/api/geocode/json',
        data: {key: process.env.GOOGLE_MAPS_API_KEY, latlng: e.latlng.lat + ',' + e.latlng.lng, language: 'es'}
      }).done(function (response) {
        th.title = response.results[0].formatted_address;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/StreetView.vue